import React from 'react';
import { Link } from 'react-router-dom';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="legal-container">
      <h1>Terms of Service</h1>
      <p>Last Updated: May 5, 2026</p>
      
      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing and using the Hive Hub website and services, you agree to be bound by these Terms of Service.</p>
      </section>

      <section>
        <h2>2. SMS/Text Messaging Terms</h2>
        <p><strong>Program Description:</strong> By opting in via our contact form at <a href="https://hivesolutions.biz/contact">hivesolutions.biz/contact</a>, you are subscribing to the Hive Hub Notifications program. This program sends automated notifications, project updates, and direct responses to inquiries regarding our tech and fintech services.</p>
        
        <p><strong>Message Frequency:</strong> Message frequency varies based on your interactions and project needs.</p>
        
        <p><strong>Rates:</strong> As always, message and data rates may apply for any messages sent to you from us and to us from you. If you have any questions about your text plan or data plan, it is best to contact your wireless provider.</p>
        
        <p><strong>Support:</strong> If you are experiencing issues with the messaging program you can reply with the keyword <strong>HELP</strong> for more assistance, or you can get help directly at <a href="mailto:g.nunez.2803@gmail.com">g.nunez.2803@gmail.com</a>.</p>
        
        <p><strong>Opt-Out:</strong> You can cancel the SMS service at any time. Just text <strong>STOP</strong> to our number. After you send the SMS message <strong>STOP</strong> to us, we will send you an SMS message to confirm that you have been unsubscribed. After this, you will no longer receive SMS messages from us. If you want to join again, just sign up as you did the first time and we will start sending SMS messages to you again.</p>
        
        <p><strong>Carrier Liability:</strong> Carriers are not liable for delayed or undelivered messages.</p>
        
        <p><strong>Privacy:</strong> Please review our <Link to="/privacy">Privacy Policy</Link> to understand how we handle your data.</p>
      </section>
      
      <section>
        <h2>3. Contact Information</h2>
        <p>If you have any questions about these Terms, please contact us at g.nunez.2803@gmail.com.</p>
      </section>
    </div>
  );
};

export default TermsOfService;
